<div class="info-teasers" [attr.viewport]="viewport">
  <div
    class="info-teasers__item"
    *ngFor="let infoTeaser of infoTeasers | slice: 0 : 6; let i = index"
  >
    <div *ngIf="numbering" class="info-teasers__item__round-number">
      <h4>{{ i + 1 }}</h4>
    </div>
    <hdi-icon
      class="info-teasers__item__icon"
      [size]="Sizes.XXXLARGE"
      [color]="Colors.GREEN"
      [iconName]="infoTeaser.icon"
    ></hdi-icon>
    <h4
      #text
      class="info-teasers__item__text"
      [innerHTML]="infoTeaser.text"
    ></h4>
  </div>
</div>
